import { render } from "./PropostasForm.vue?vue&type=template&id=3bd4de66"
import script from "./PropostasForm.vue?vue&type=script&lang=js"
export * from "./PropostasForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__